import { Col, Container, Row } from 'react-bootstrap';

import './CommunitySpirit.css';

const CommunitySpirit = () => {
  return (
    <Container>
      <Row>
        <Col xs={12}>
          <div className="home-description-text">
            <p>
              At Aparna Western Meadows, we aim to create a living experience
              that prioritizes comfort, safety, and community spirit. Our
              thoughtfully designed spaces and comprehensive security measures
              ensure that residents can enjoy a peaceful and fulfilling
              lifestyle within our thriving community.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default CommunitySpirit;
